import { ROUTES } from '@/app/routes';

const ADMIN_USER_SENDER_RUN_PATH = /^\/admin\/users\/(\d+)\/sender\/runs\/[^/]+$/;

/** Whether pathname is admin user sender run detail. */
export function isAdminUserSenderRunDetailPath(pathname: string): boolean {
	return ADMIN_USER_SENDER_RUN_PATH.test(pathname);
}

export function resolveAdminBackPath(pathname: string): string | null {
	const runDetailMatch = pathname.match(ADMIN_USER_SENDER_RUN_PATH);
	if (runDetailMatch) {
		return `${ROUTES.adminUser}${runDetailMatch[1]}?tab=sender`;
	}

	if (pathname.startsWith(ROUTES.adminUser) && pathname !== ROUTES.adminUsers) {
		return ROUTES.adminUsers;
	}

	if (
		pathname === ROUTES.adminStats ||
		pathname === ROUTES.adminSettings ||
		pathname === ROUTES.adminSenderProxies ||
		pathname === ROUTES.adminBuilderQueue ||
		pathname === ROUTES.adminCardFill
	) {
		return ROUTES.admin;
	}

	if (pathname === ROUTES.adminUsers) {
		return ROUTES.admin;
	}

	if (pathname === ROUTES.admin) {
		return ROUTES.myClients;
	}

	return null;
}
